
import { MESSAGE,MOVIES,MOVIE,MOVIE_WATCH_USER, MOVIE_LINK_DELETE,MOVIE_NAME, VIDEO_LINK_DELETE, MOVIE_REPORT } from '../../constants/actionTypes';
import * as api from '../../api/index.js';


export const movie_create = (formData) => async (dispatch) => {
    try {
      const { data } = await api.movie_create(formData);
      dispatch({ type: MESSAGE, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };

  export const movie_update = (formData) => async (dispatch) => {
    try {
      const { data } = await api.movie_update(formData);
      dispatch({ type: MESSAGE, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };
  export const movie_delete = (formData) => async (dispatch) => {
    try {
      const { data } = await api.movie_delete(formData);
      dispatch({ type: MESSAGE, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };
  export const all_movie_list = (formData) => async (dispatch) => {
    try {
      const { data } = await api.all_movie_list(formData);
      dispatch({ type: MOVIES, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };
  
  export const movie_details = (formData) => async (dispatch) => {
    try {
      const { data } = await api.movie_details(formData);
      dispatch({ type: MOVIE, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };
  export const movie_watch_user_list = (formData) => async (dispatch) => {
    try {
      const { data } = await api.movie_watch_user_list(formData);
      dispatch({ type: MOVIE_WATCH_USER, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };
  export const movie_send_notification = (formData) => async (dispatch) => {
    try {
      const { data } = await api.movie_send_notification(formData);
      dispatch({ type: MESSAGE, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };
  export const video_link_delete = (formData) => async (dispatch) => {
    try {
      const { data } = await api.video_link_delete(formData);
      dispatch({ type: VIDEO_LINK_DELETE, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };
  
  export const movie_name_listing = (formData) => async (dispatch) => {
    try {
      const { data } = await api.movie_name_listing(formData);
      dispatch({ type: MOVIE_NAME, payload:data });
  
   
    } catch (error) {
      console.log(error);
    }
  };
  
  
  export const movie_report = (formData) => async (dispatch) => {
    try {
      const { data } = await api.movie_report(formData);
      dispatch({ type: MOVIE_REPORT, payload:data });
      return data
  
   
    } catch (error) {
      console.log(error);
    }
  };
  
 
  